import { Route, Routes } from 'react-router-dom';
import { InformationDetail } from '../pages/hotel-information/InformationDetail';
import { MainSection } from '../pages/hotel-information/MainSection';
import { CheckInProcess } from '../pages/hotel-information/views/CheckInProcess';
import { CheckOutProcess } from '../pages/hotel-information/views/CheckOutProcess';
import { CleanVerification } from '../pages/hotel-information/views/CleanVerification';
import { CodeOfConduct } from '../pages/hotel-information/views/CodeOfConduct';
import { CovidInfo } from '../pages/hotel-information/views/CovidInfo';
import { CrystalStd } from '../pages/hotel-information/views/CrystalStd';
import { HotelSanitation } from '../pages/hotel-information/views/HotelSanitation';
import { Regulation } from '../pages/hotel-information/views/Regulation';
import { Security } from '../pages/hotel-information/views/Security';

export const HotelInformationRouter = () => {
    return (
        <Routes>
            <Route path="/" element={<MainSection />} />
            <Route path="/detail/:InfoDetailId" element={<InformationDetail />} />

            <Route path="/regulation" element={<Regulation />} />
            <Route path="/security" element={<Security />} />
            <Route path="/code-of-conduct" element={<CodeOfConduct />} />
            <Route path="/covid-info" element={<CovidInfo />} />
            <Route path="/sanitation-info" element={<HotelSanitation />} />
            <Route path="/check-in" element={<CheckInProcess />} />
            <Route path="/check-out" element={<CheckOutProcess />} />
            <Route path="/crystal-std-info" element={<CrystalStd />} />
            <Route path="/clean-verification-info" element={<CleanVerification />} />
        </Routes>
    );
};
